import { environment } from './environments/environment';

export interface Environment {
  production: boolean;
  hostname: string;
  protocol: string;
  port: string;
}

export namespace Setting {
  export function getProtocol() {
    return environment.protocol;
  }
  export function getOrigin() {
    return environment.protocol + getHost();
  }
  export function getPort() {
    return environment.port;
  }
  export function getHostname() {
    return environment.hostname;
  }
  export function getHost() {
    if (environment.port) {
      return environment.hostname + ':' + environment.port;
    } else {
      return environment.hostname;
    }
  }
}
